import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handleGetRequest } from "../../services/GetTemplate";
import { handlePostRequest } from "../../services/PostTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import LodegmentSubDetailForm from "./LodegmentSubDetailForm";
import * as Yup from "yup";

function Lodegment() {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [productColl, setproductColl] = useState([]);
    const [branch, setBranch] = useState([]);
    const [lodegmentData, setLodegmentData] = useState([]);
    const [selectedCustomers, setSelectedCustomers] = useState(null);
    const [displaySubDetailsModal, setDisplaySubDetailsModal] = useState(false);
    const [lodgementStatus, setlodgementStatus] = useState(false);
    const [transHeadId, settransHeadId] = useState([]);

    const getBranch = async () => {
        setloading(true);
        const response = await handleGetRequest("zbizgateway/lov/lovBranch");
        setBranch(response?.data);
        setloading(false);
    };

    useEffect(() => {
        getBranch();
    }, []);

    const getProductColl = async () => {
        setloading(true);
        const response = await handleGetRequest("zbizgateway/lov/lovProductCollection");
        setproductColl(response?.data);
        setloading(false);
    };

    useEffect(() => {
        getProductColl();
    }, []);

    const handleAddNewSubDetails = (e, status) => {
        e.preventDefault();
        setlodgementStatus(status);
        setDisplaySubDetailsModal(true);
    };
    const onRowSelect = (event) => {
        settransHeadId([event?.data?.transHeadId]);
    };

    const validationSchema = Yup.object().shape({
        branchId: Yup.mixed().required("This field is required."),
        productCollCode: Yup.mixed().required("This field is required."),
        chqNo: Yup.string().max(20, "Maximum length 20 allowed").matches("^[0-9]*$", "Please enter numeric data").nullable(),
        invoiceNo: Yup.string().max(20, "Maximum length 20 allowed").matches("^[0-9]*$", "Please enter numeric data").nullable(),
        amount: Yup.string().max(10, "Maximum length 10 allowed").matches("^[0-9]*$", "Please enter numeric data").nullable(),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            branchId: "",
            chqNo: null,
            invoiceNo: null,
            amount: null,
            productCollCode: "",
        },

        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            data["branchId"] = data?.branchId?.id;
            data["productCollCode"] = data?.productCollCode?.code;
            const lodegmentArray = await handlePostRequest(data, "zbizgateway/fin/collection/fetchLodgementChq");
            setLodegmentData(lodegmentArray.data);
            // getBranch();
            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Lodegment</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="baseLocationId" className={classNames({ "p-error": isFormFieldValid("baseLocationId") }, "Label__Text")}>
                                    Branch<span className="Label__Required">*</span>
                                </label>
                                <Dropdown id="branchId" placeholder="Select branch" options={branch} optionLabel="description" name="branchId" value={formik.values.branchId} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("branchId") }, "Dropdown__Round")} />
                                {getFormErrorMessage("branchId")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="chqNo" className={classNames({ "p-error": isFormFieldValid("chqNo") }, "Label__Text")}>
                                    Cheque No.
                                </label>
                                <InputText id="chqNo" placeholder="Enter cheque no" name="chqNo" value={formik.values.chqNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("chqNo") }, "Input__Round")} />

                                {getFormErrorMessage("chqNo")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="invoiceNo" className={classNames({ "p-error": isFormFieldValid("invoiceNo") }, "Label__Text")}>
                                    Deposit Slip No.
                                </label>
                                <InputText id="invoiceNo" placeholder="Enter deposit slip no" name="invoiceNo" value={formik.values.invoiceNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("invoiceNo") }, "Input__Round")} />

                                {getFormErrorMessage("invoiceNo")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="amount" className={classNames({ "p-error": isFormFieldValid("amount") }, "Label__Text")}>
                                    Amount
                                </label>
                                <InputText id="amount" placeholder="Enter amount" name="amount" value={formik.values.amount} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("amount") }, "Input__Round")} />

                                {getFormErrorMessage("amount")}
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="productCollCode" className={classNames({ "p-error": isFormFieldValid("productCollCode") }, "Label__Text")}>
                                    Product Collection<span className="Label__Required">*</span>
                                </label>

                                <Dropdown
                                    id="productCollCode"
                                    placeholder="Select product collection"
                                    options={productColl}
                                    optionLabel="description"
                                    name="productCollCode"
                                    value={formik.values.productCollCode}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("productCollCode") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("productCollCode")}
                            </div>
                        </div>
                    </div>
                    <div className="Down__Btn">
                        <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label="Fetch" className="Btn__Dark" />
                    </div>
                </form>
            </div>

            <div className="card p-datatable-sm">
                <DataTable header="" loading={loading} onRowSelect={onRowSelect} value={lodegmentData} selection={selectedCustomers} onSelectionChange={(e) => setSelectedCustomers(e.value)} paginator rows={6} emptyMessage="No data found.">
                    <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column>
                    <Column field="companyName" header="Company Name" />
                    <Column field="branchName" header="Branch Name" />
                    <Column field="bankName" header="Bank Name" />
                    <Column field="depositSlipNo" header="Deposit Slip No." />
                    <Column field="chqNo" header="Cheque No." />
                    <Column field="chqDate" header="Cheque Date" />
                    <Column field="depositSlipAmount" header="Amount" />
                    <Column field="department" header="Clearing Date" />
                    <Column field="department" header="Lodge/Reject" />
                    <Column field="department" header="Reason" />
                    <Column field="department" header="Status" />
                </DataTable>
            </div>
            <br />
            <div className="Down__Btn">
                <Button label="Reject" className="Btn__Transparent" onClick={(e) => handleAddNewSubDetails(e, "R")} />
                <Button disabled={loading} onClick={(e) => handleAddNewSubDetails(e, "A")} label="Approve" className="Btn__Dark" />
            </div>
            <Dialog visible={displaySubDetailsModal} style={{ width: "50vw" }} onHide={() => setDisplaySubDetailsModal(false)}>
                <LodegmentSubDetailForm lodgementStatus={lodgementStatus} transHeadId={transHeadId} />
            </Dialog>
        </>
    );
}

export default Lodegment;
